import React, { useState, useEffect } from 'react';
import QlikSaasSingleSignOn from './QlikSaasSingleSignOn';
import AuthLayout from 'components/layout/AuthLayout';
import { Box, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { qsServerSelector } from 'redux/qsServer/selector';

const QlikSaasLogin = () => {
    const [showQlikSaasLogin, setShowQlikSaasLogin] = useState(false);
    const qsServer = useSelector(qsServerSelector);

    useEffect(() => {
        if (qsServer && qsServer.webIntegrationId && qsServer.tenantUri) {
            setShowQlikSaasLogin(true);
        }
    }, [qsServer]);

    return (
        <AuthLayout>
            <Box>
                <Typography
                    variant="overline"
                    className="u-p-small u-text-center"
                >
                    Sign In
                </Typography>
                {showQlikSaasLogin && (
                    <QlikSaasSingleSignOn
                        webIntegrationId={qsServer.webIntegrationId}
                        tenantUri={qsServer.tenantUri}
                    />
                )}
            </Box>
        </AuthLayout>
    );
};

export default QlikSaasLogin;
